import React from "react";
import { ClinicalDashboard } from "../Clinical";

/**
 * PCP Dashboard
 * Renderiza el nuevo Clinical Dashboard completo.
 */
export default function PCPDashboard() {
  return <ClinicalDashboard />;
}
